import {talentSearchTypes} from "../../actions/Dashboard/TalentSearch/actionsType";

export const initState = {
    search: null,
    tempSearch: null,
    filters: {
        performance: {},
        regions: [],
        countries: [],
        seasons: [],
        competitions: [],
    },
    datatable: {
        selectedPlayers: [],
        expandedRows: [],
        currentPage: 1,
        pageSize: 10,
        sortField: null,
        sortOrder: null,
    },
};

const TalentSearchReducer = (state = initState, action) => {
    switch (action.type) {
        // Filters
        case talentSearchTypes.SET_PERFORMANCE_FILTERS: {
            return Object.assign({}, state, {
                ...state,
                filters: {
                    ...state.filters,
                    performance: action.performance
                },
            });
        }

        case talentSearchTypes.SET_PERFORMANCE_GROUP_FILTERS: {
            return Object.assign({}, state, {
                ...state,
                filters: {
                    ...state.filters,
                    performance: {
                        ...state.filters.performance,
                        [action.groupName]: action.filters
                    }
                },
            });
        }

        // Regions, Countries, Seasons, Competitions.
        case talentSearchTypes.SET_REGIONS_FILTER:
        case talentSearchTypes.SET_COUNTRIES_FILTER:
        case talentSearchTypes.SET_SEASONS_FILTER:
        case talentSearchTypes.SET_COMPETITIONS_FILTER : {
            delete action.type;
            return Object.assign({}, state, {
                ...state,
                filters: {
                    ...state.filters,
                    ...action,
                }
            });
        }

        case talentSearchTypes.INIT_FILTERS: {
            return Object.assign({}, state, {
                ...state,
                filters: action.initFilters,
            });
        }

        case talentSearchTypes.CLEAR_FILTERS: {
            return Object.assign({}, state, {
                ...state,
                filters: initState.filters,
            });
        }


        case talentSearchTypes.TOGGLE_SELECT_PLAYER: {
            const selectedPlayers = state.datatable.selectedPlayers;
            const exists = selectedPlayers.map(player => player.id).indexOf(action.player.id) !== -1;

            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    selectedPlayers: exists ? selectedPlayers.filter(player => player.id !== action.player.id) : [...selectedPlayers, action.player]
                },
            });
        }

        // Pagination
        case talentSearchTypes.SET_PAGINATION: {
            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    ...action.pagination,
                },
            });
        }

        // Search
        case talentSearchTypes.SET_SEARCH_VALUE: {
            return Object.assign({}, state, {
                ...state,
                search: action.search,
            });
        }

        case talentSearchTypes.SET_TEMP_SEARCH_VALUE: {
            return Object.assign({}, state, {
                ...state,
                tempSearch: action.search,
            });
        }

        // Expand
        case talentSearchTypes.SET_EXPAND_ROW: {
            const expandedRows = state.datatable.expandedRows;

            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    expandedRows: action.isExpand ? [...expandedRows, action.row] :
                        expandedRows.filter(row => row.id !== action.row.id)
                },
            });
        }

        case talentSearchTypes.SET_SORT: {
            console.log(action);
            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    sortField: action.field,
                    sortOrder: action.order,
                }
            });
        }

        default: {
            return state;
        }
    }
};

export default TalentSearchReducer;
